import {RestService} from "@/services/rest/RestService";
import {ContentBlockLibraryEndpointsApi} from "@/api/pharma-cms-content-page";
import {FullContentPageRestDto, PageLibraryOverviewRestDto} from "@/api/pharma-cms-content-page/models";
import {StatusEnum} from "@/api/enums/status-enum";

export class ContentPageLibraryRestService extends RestService {

    private apiService: ContentBlockLibraryEndpointsApi;

    protected constructor() {
        super();

        this.apiService = new ContentBlockLibraryEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async findContentPageLibrariesForContentProvider(): Promise<PageLibraryOverviewRestDto[]> {
        const response = await this.apiService.pageLibraryOverviewRestDto();

        return response.data;
    }

    public async findLibContentPages(libCode: string): Promise<FullContentPageRestDto[]> {
        const response = await this.apiService.getLibraryContentBlocksContentPage(libCode, undefined, StatusEnum.PUBLISHED);

        return response.data;
    }
}
